import { PostPaymentProvider } from '@context/Payment/PostPayment';

import PostPaymentView from './PostPaymentView';

const PostPayment = () => {
  return (
    <PostPaymentProvider>
      <PostPaymentView />
    </PostPaymentProvider>
  );
}

export default PostPayment;
